import React, { useState, useEffect } from 'react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Label } from '../ui/Label';
import { toast } from 'react-toastify';
import { createLocalSessao, updateLocalSessao } from '../../services/api';
import { cn } from '../../lib/utils'; // Importar cn para classes condicionais

function LocalSessaoForm({ localSessao, sessaoId, onSuccess, onCancel }) {
    const [formData, setFormData] = useState({
        nomeCompleto: '',
        codigoSala: '',
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({}); // Novo estado para erros de validação

    useEffect(() => {
        if (localSessao) {
            setFormData({
                nomeCompleto: localSessao.nomeCompleto || '',
                codigoSala: localSessao.codigoSala || '',
            });
        } else {
            setFormData({
                nomeCompleto: '',
                codigoSala: '',
            });
        }
        setErrors({}); // Limpa erros ao carregar/resetar
    }, [localSessao]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Limpa o erro ao digitar
        setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.nomeCompleto) newErrors.nomeCompleto = 'O nome completo do local é obrigatório.';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            toast.error('Por favor, preencha todos os campos obrigatórios.');
            return;
        }

        setIsSubmitting(true);

        try {
            if (localSessao) {
                await updateLocalSessao(localSessao.id, formData);
            } else {
                await createLocalSessao(sessaoId, formData);
            }
            toast.success(`Local de Sessão ${localSessao ? 'atualizado' : 'criado'} com sucesso!`);
            onSuccess();
        } catch (err) {
            console.error("Erro no formulário do local de sessão:", err);
            toast.error(err.message || 'Ocorreu um erro ao processar sua requisição.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid gap-2">
                <Label htmlFor="nomeCompleto" className="mb-1">Nome Completo do Local:</Label> {/* Adicionado mb-1 */}
                <Input
                    id="nomeCompleto"
                    name="nomeCompleto"
                    value={formData.nomeCompleto}
                    onChange={handleChange}
                    required
                    disabled={isSubmitting}
                    className={cn(errors.nomeCompleto && 'border-destructive focus-visible:ring-destructive')}
                />
                {errors.nomeCompleto && <p className="text-xs text-destructive">{errors.nomeCompleto}</p>}
            </div>
            <div className="grid gap-2">
                <Label htmlFor="codigoSala" className="mb-1">Código da Sala (Opcional):</Label> {/* Adicionado mb-1 */}
                <Input
                    id="codigoSala"
                    name="codigoSala"
                    value={formData.codigoSala}
                    onChange={handleChange}
                    disabled={isSubmitting}
                />
            </div>
            <div className="flex flex-col sm:flex-row justify-end gap-2"> {/* Adicionado flex-col sm:flex-row e gap-2 */}
                <Button type="button" variant="secondary" onClick={onCancel} disabled={isSubmitting} className="w-full sm:flex-1">
                    Cancelar
                </Button>
                <Button type="submit" disabled={isSubmitting} className="w-full sm:flex-1">
                    {isSubmitting ? 'A guardar...' : (localSessao ? 'Atualizar Local' : 'Criar Local')}
                </Button>
            </div>
        </form>
    );
}

export default LocalSessaoForm;